// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wacom-sign {
  margin: 5vh;
  margin: 5vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wacom-sign_img {
  width: 666px;
  height: 283px;
  border: 2px solid gray;
}

.wacom-sign_video {
  width: 666px;
  height: 283px;
  border: 2px solid lightblue;
}

.wacom-sing-toolbar {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

button {
  margin: 1vh;
}`, "",{"version":3,"sources":["webpack://./src/webid/4.0/projects/controls/src/lib/dev/wacom-sign/wacom-sign.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAEA;EACI,YAAA;EACA,aAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AACJ;;AACA;EACI,WAAA;AAEJ","sourcesContent":[".wacom-sign {\n    margin: 5vh;\n    margin: 5vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center\n}\n\n.wacom-sign_img {\n    width: 666px;\n    height: 283px;\n    border: 2px solid gray;\n}\n\n.wacom-sign_video {\n    width: 666px;\n    height: 283px;\n    border: 2px solid lightblue;\n}\n\n.wacom-sing-toolbar {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n}\nbutton {\n    margin: 1vh;\n}\n\n.wacom-sign-toolbar_button_start {\n\n}\n\n.wacom-sign-toolbar_button_stop {\n\n}\n\n.wacom-sign-toolbar_dash {\n\n}\n\n.wacom-sign-toolbar_clear {\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
